import script from "./ActionSettings.vue?vue&type=script&lang=js"
export * from "./ActionSettings.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__